/* Login Page */
export const LOGIN_PAGE_START_LOADING = "LOGIN_PAGE_START_LOADING";
export const LOGIN_PAGE_LOGIN_SUCCESS = "LOGIN_PAGE_LOGIN_SUCCESS";
export const LOGIN_PAGE_LOGIN_FAIL = "LOGIN_PAGE_LOGIN_FAIL";

/* Notification */
export const NOTI_COMP_START_LOAD = "NOTI_COMP_START_LOAD";
export const NOTI_COMP_END_LOAD = "NOTI_COMP_END_LOAD";
export const NOTI_COMP_LOAD_FAIL = "NOTI_COMP_LOAD_FAIL";
export const NOTI_COMP_DELETE = "NOTI_COMP_DELETE";

/* Title List */
export const TITLE_LIST_START_LOAD = "TITLE_LIST_START_LOAD";
export const TITLE_LIST_END_LOAD = "TITLE_LIST_END_LOAD";
export const TITLE_LIST_LOAD_FAIL = "TITLE_LIST_LOAD_FAIL";
export const TITLE_LIST_FILTER_KEYWORD_ENTERED =
  "TITLE_LIST_FILTER_KEYWORD_ENTERED";
export const TITLE_LIST_DEL_START = "TITLE_DEL_START";
export const TITLE_LIST_START_CREATE = "TITLE_LIST_START_CREATE";
export const TITLE_LIST_END_CREATE = "TITLE_LIST_END_CREATE";
export const TITLE_LIST_SHOW_CREATE = "TITLE_LIST_SHOW_CREATE";
export const TITLE_LIST_HIDE_CREATE = "TITLE_LIST_HIDE_CREATE";
export const TITLE_LIST_EDIT_TITLE = "TITLE_LIST_EDIT_TITLE";
export const TITLE_LIST_EDIT_TITLE_START_LOAD =
  "TITLE_LIST_EDIT_TITLE_START_LOAD";
export const TITLE_LIST_EDIT_TITLE_END_LOAD = "TITLE_LIST_EDIT_TITLE_END_LOAD";
export const TITLE_LIST_EDIT_TITLE_COMPLETE = "TITLE_LIST_EDIT_TITLE_COMPLETE";
export const TITLE_LIST_RECOVER_TITLE = "TITLE_LIST_RECOVER_TITLE";

/* App Titles */
export const APP_TITLES_SET = "APP_TITLES_SET";

/* App Issues */
export const APP_ISSUES_SET = "APP_ISSUES_SET";

/* Issue List */
export const ISSUE_LIST_START_LOAD = "ISSUE_LIST_START_LOAD";
export const ISSUE_LIST_END_LOAD = "ISSUE_LIST_END_LOAD";
export const ISSUE_LIST_LOAD_FAIL = "ISSUE_LIST_LOAD_FAIL";
export const ISSUE_LIST_FILTER_KEYWORD_ENTERED =
  "ISSUE_LIST_FILTER_KEYWORD_ENTERED";
export const ISSUE_LIST_DEL_START = "ISSUE_LIST_DEL_START";
export const ISSUE_LIST_SHOW_CREATE = "ISSUE_LIST_SHOW_CREATE";
export const ISSUE_LIST_HIDE_CREATE = "ISSUE_LIST_HIDE_CREATE";
export const ISSUE_LIST_RECOVER_ISSUE = "ISSUE_LIST_RECOVER_ISSUE";
export const ISSUE_LIST_UPDATE_CUR_ISSUE = "ISSUE_LIST_UPDATE_CUR_ISSUE";

/* App Issues */
export const APP_ISSUES_PROD_SET = "APP_ISSUES_PROD_SET";

/* Article List */
export const ARTICLE_LIST_START_LOAD = "ARTICLE_LIST_START_LOAD";
export const ARTICLE_LIST_END_LOAD = "ARTICLE_LIST_END_LOAD";
export const ARTICLE_LIST_LOAD_FAIL = "ARTICLE_LIST_LOAD_FAIL";
export const ARTICLE_LIST_UPDATE_AN_ARTICLE_META =
  "ARTICLE_LIST_UPDATE_AN_ARTICLE_META";

/* Upload Media Item */
export const UPLOAD_ITEM_SET_DATA = "UPLOAD_ITEM_SET_DATA";
export const UPLOAD_ITEM_APPEND_DATA = "UPLOAD_ITEM_APPEND_DATA";
export const UPLOAD_ITEM_SET_LOADED_ID = "UPLOAD_ITEM_SET_LOADED_ID";
export const UPLOAD_ITEM_LOADED_ERR = "UPLOAD_ITEM_LOADED_ERR";
export const MODIFY_UPLOAD_ITEM = "MODIFY_UPLOAD_ITEM";
export const REMOVE_MEDIA_ITEM = "REMOVE_MEDIA_ITEM";

/* Copy Moal */
export const SHOW_COPY_MODAL = "SHOW_COPY_MODAL";

/* Toc Edit Panel */
export const TOC_PANEL_START_LOAD = "TOC_PANEL_START_LOAD ";
export const TOC_PANEL_END_LOAD = "TOC_PANEL_END_LOAD";
export const TOC_PANEL_LOAD_FAIL = "TOC_PANEL_LOAD_FAIL";
export const TOC_PANEL_MODIFY_ONE_ITEM = "TOC_PANEL_MODIFY_ONE_ITEM";
export const TOC_PANEL_RECOVER = "TOC_PANEL_RECOVER";
export const TOC_PANEL_STATE_SNAPSHOT = "TOC_PANEL_STATE_SNAPSHOT";
export const TOC_PANEL_DELETE_ARTICLE = "TOC_PANEL_DELETE_ARTICLE";
export const TOC_PANEL_APPEND_ARTICLE = "TOC_PANEL_APPEND_ARTICLE";
export const TOC_PANEL_API_SET_ARTICLE_TITLE =
  "TOC_PANEL_API_SET_ARTICLE_TITLE";
export const TOC_PANEL_API_SET_ARTICLE_READY =
  "TOC_PANEL_API_SET_ARTICLE_READY";
export const TOC_PANEL_MANUAL_CREATE_ARTICLE =
  "TOC_PANEL_MANUAL_CREATE_ARTICLE";
export const TOC_PANEL_MERGE_ARTICLE = "TOC_PANEL_MERGE_ARTICLE";
export const TOC_PANEL_SAVE_LOADING = "TOC_PANEL_SAVE_LOADING";
export const TOC_PANEL_LOCK_ITEM = "TOC_PANEL_LOCK_ITEM";
export const TOC_PANEL_MERGE_TO_LOCK = "TOC_PANEL_MERGE_TO_LOCK";
export const TOC_PANEL_CHANGE_MODE = "TOC_PANEL_CHANGE_MODE";
export const TOC_PANEL_ENTER_DESCRIPTION = "TOC_PANEL_ENTER_DESCRIPTION";

/* Pdf Edit Toc Container */
export const SWITCH_ZOOM = "SWITCH_ZOOM";
export const NO_ZOOM = "NO_ZOOM";

/* Edit Article Panel */
export const EDIT_ARTICLE_PANEL_CHANGE_MODE = "EDIT_ARTICLE_PANEL_CHANGE_MODE";
export const EDIT_ARTICLE_PANEL_SET_ARTICLE = "EDIT_ARTICLE_PANEL_SET_ARTICLE";
export const EDIT_ARTICLE_PANEL_SNAPSHOT_META =
  "EDIT_ARTICLE_PANEL_SNAPSHOT_META";
export const EDIT_ARTICLE_PANEL_RECOVER_META =
  "EDIT_ARTICLE_PANEL_RECOVER_META";
export const EDIT_ARTICLE_PANEL_UPDATE_META_TEXT =
  "EDIT_ARTICLE_PANEL_UPDATE_META_TEXT";
export const EDIT_ARTICLE_PANEL_RECOVER_CONTENT =
  "EDIT_ARTICLE_PANEL_RECOVER_CONTENT";
export const EDIT_ARTICLE_PANEL_UPDATE_CONTRI_NAME =
  "EDIT_ARTICLE_PANEL_UPDATE_CONTRI_NAME";
export const EDIT_ARTICLE_PANEL_LOCK_ID = "EDIT_ARTICLE_PANEL_LOCK_ID";
export const EDIT_ARTICLE_PANEL_API_SET_TEXT =
  "EDIT_ARTICLE_PANEL_API_SET_TEXT";
export const EDIT_ARTICLE_PANEL_SET_ITEM = "EDIT_ARTICLE_PANEL_SET_ITEM";
export const EDIT_ARTICLE_PANEL_APPEND_CONTENT =
  "EDIT_ARTICLE_PANEL_APPEND_CONTENT";
export const EDIT_ARTICLE_PANEL_APPEND_CONTENT_NO_RECOVER =
  "EDIT_ARTICLE_PANEL_APPEND_CONTENT_NO_RECOVER";
export const EDIT_PANEL_ARTICLE_DELETE_CONTENT =
  "EDIT_PANEL_ARTICLE_DELETE_CONTENT";
export const EDIT_ARTICLE_PANEL_SNAPSHOT_CONTENT =
  "EDIT_ARTICLE_PANEL_SNAPSHOT_CONTENT";
export const EDIT_ARTICLE_PANEL_UPDATE_CONTENT_TEXT =
  "EDIT_ARTICLE_PANEL_UPDATE_CONTENT_TEXT";
export const EDIT_ARTICLE_PANEL_CREATE_ITEM = "EDIT_ARTICLE_PANEL_CREATE_ITEM";
export const EDIT_ARTICLE_PANEL_SET_PREVIEW_OFFSET =
  "EDIT_ARTICLE_PANEL_SET_PREVIEW_OFFSET";
export const EDIT_ARTICLE_PANEL_PUSH_CONTRIBUTOR_NAME =
  "EDIT_ARTICLE_PANEL_PUSH_CONTRIBUTOR_NAME";
export const EDIT_ARTICLE_PANEL_DEL_CONTRIBUTOR_NAME =
  "EDIT_ARTICLE_PANEL_DEL_CONTRIBUTOR_NAME";
export const EDIT_ARTICLE_PANEL_INSERT_IMAGE_ARR =
  "EDIT_ARTICLE_PANEL_INSERT_IMAGE_ARR";
export const EDIT_ARTICLE_PANEL_DEL_IMAGE_ARR =
  "EDIT_ARTICLE_PANEL_DEL_IMAGE_ARR";
export const EDIT_ARTICLE_PANEL_SET_SUB_LOCKING_ID =
  "EDIT_ARTICLE_PANEL_SET_SUB_LOCKING_ID";
export const EDIT_ARTICLE_PANEL_SET_SUB_ITEM =
  "EDIT_ARTICLE_PANEL_SET_SUB_ITEM";
export const EDIT_ARTICLE_PANEL_SET_SUB_ITEM_TEXT =
  "EDIT_ARTICLE_PANEL_SET_SUB_ITEM_TEXT";
export const EDIT_ARTICLE_PANEL_UPDATE_SUB_ITEM_TEXT =
  "EDIT_ARTICLE_PANEL_UPDATE_SUB_ITEM_TEXT";
export const EDIT_ARTICLE_PANEL_SET_PREVIEW_TEXT_LINE_IDS =
  "EDIT_ARTICLE_PANEL_SET_PREVIEW_TEXT_LINE_IDS";
export const EDIT_ARTICLE_PANEL_SET_PREVIEW_IMAGE_IDS =
  "EDIT_ARTICLE_PANEL_SET_PREVIEW_IMAGE_IDS";
export const EDIT_ARTICLE_PANEL_SET_PREVIEW_ITEM_HIDING_MODE =
  "EDIT_ARTICLE_PANEL_SET_PREVIEW_ITEM_HIDING_MODE";
export const EDIT_ARTICLE_PANEL_SET_ALL_PREVIEW_ITEM_HIDING_MODE =
  "EDIT_ARTICLE_PANEL_SET_ALL_PREVIEW_ITEM_HIDING_MODE";

/* PDF Edit Article AV List */
export const SET_MEDIAS_ACTION = "SET_MEDIAS_ACTION";
export const SET_MEDIAS_USED_ACTION = "SET_MEDIAS_USED_ACTION";

/* Single Pdf Page Container */
export const SET_PDF_IMAGE_BOXES = "SET_PDF_IMAGE_BOXES";
